export let RenderTag = /*#__PURE__*/function (RenderTag) {
  RenderTag[RenderTag["ROOT"] = 1] = "ROOT";
  RenderTag[RenderTag["BRICK"] = 2] = "BRICK";
  RenderTag[RenderTag["ABSTRACT"] = 3] = "ABSTRACT";
  return RenderTag;
}({});
//# sourceMappingURL=enums.js.map